// Reviews carousel — shows 3 cards at a time, slides by 3, autoplay every 10s
const PER_PAGE = 3;
const AUTOPLAY_MS = 10000;

function initReviewsCarousel(section) {
  if (section.dataset.reviewsBound) return;
  section.dataset.reviewsBound = "true";

  const track   = section.querySelector("[data-reviews-track]");
  const prevBtn = section.querySelector("[data-reviews-prev]");
  const nextBtn = section.querySelector("[data-reviews-next]");
  const dotsWrap = section.querySelector("[data-reviews-dots]");
  if (!track) return;

  const cards = Array.from(track.children);
  const total = cards.length;
  let page = 0;
  let autoplayTimer = null;

  function pp()  { return window.innerWidth <= 740 ? 1 : PER_PAGE; }
  function max() { return Math.ceil(total / pp()) - 1; }

  function cardWidth() { return cards[0]?.getBoundingClientRect().width ?? 0; }
  function gapWidth()  { return parseFloat(getComputedStyle(track).columnGap) || 0; }

  // ── Dots ───────────────────────────────────────────────────────────────
  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = "";
    const count = max() + 1;
    for (let i = 0; i < count; i++) {
      const dot = document.createElement("button");
      dot.className = "reviews-dot";
      dot.setAttribute("aria-label", `Pagina ${i + 1}`);
      dot.addEventListener("click", () => { page = i; updatePosition(); resetAutoplay(); });
      dotsWrap.appendChild(dot);
    }
  }

  function updateDots() {
    if (!dotsWrap) return;
    dotsWrap.querySelectorAll(".reviews-dot").forEach((dot, i) => {
      dot.classList.toggle("reviews-dot--active", i === page);
    });
  }

  // ── Position ───────────────────────────────────────────────────────────
  function updatePosition() {
    page = Math.min(page, max());
    const offset = page * pp() * (cardWidth() + gapWidth());
    track.style.transform = `translateX(-${offset}px)`;
    if (prevBtn) prevBtn.disabled = page === 0;
    if (nextBtn) nextBtn.disabled = page >= max();
    updateDots();
  }

  // ── Autoplay ───────────────────────────────────────────────────────────
  function startAutoplay() {
    autoplayTimer = setInterval(() => {
      page = page >= max() ? 0 : page + 1;
      updatePosition();
    }, AUTOPLAY_MS);
  }

  function resetAutoplay() {
    clearInterval(autoplayTimer);
    startAutoplay();
  }

  // ── Events ─────────────────────────────────────────────────────────────
  prevBtn?.addEventListener("click", () => {
    page = Math.max(0, page - 1);
    updatePosition();
    resetAutoplay();
  });

  nextBtn?.addEventListener("click", () => {
    page = Math.min(max(), page + 1);
    updatePosition();
    resetAutoplay();
  });

  // Pause on hover
  section.addEventListener("mouseenter", () => clearInterval(autoplayTimer));
  section.addEventListener("mouseleave", () => startAutoplay());

  window.addEventListener("resize", () => { buildDots(); updatePosition(); }, { passive: true });

  buildDots();
  updatePosition();
  startAutoplay();
}

function initAll() {
  document.querySelectorAll(".reviews-section").forEach(initReviewsCarousel);
}

document.addEventListener("turbo:load", initAll);
if (document.readyState !== "loading") initAll();

